<template>
    <div class="body">
        <div class="body-t">
           <div class="img1"></div> 学生综合评价系统自助终端
        </div>
        <div class="box">
            <div class="content" @click="enteringJump()">积分卡录入</div>
            <div class="content" @click="exchangeJump()">积分兑换</div>
        </div>
        <div class="body-b">
            <div class="img2"></div>  易学云智能
            <div class="qrCode"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "pointsHome",
        data(){
            return{

            }
        },
        created(){
        },
        methods:{
            enteringJump(){
                this.$router.push('/entering')
            },
            exchangeJump(){
                this.$router.push('/exchange')
            }
        }
    }
</script>

<style scoped>
    .body{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }
    .body-t{
        /*position: absolute;*/
        /*top: 0;*/
        /*left: 0;*/
        width: 100%;
        height: 87px;
        line-height: 87px;
        color: white;
        background: url("../../assets/pointsImgs/pointsHomebg1.png") no-repeat center 0;
        font-size: 48px;
        display: flex;
        align-items: center;
    }
    .img1{
        width: 70px;
        height: 70px;
        background: url("../../assets/pointsImgs/pointsHomebg3.png") no-repeat center 0;
        margin: 0 30px;
    }
    .body-b{
        position: relative;
        /*bottom: 0;*/
        /*left: 0;*/
        width: 100%;
        height: 121px;
        background: url("../../assets/pointsImgs/pointsHomebg2.png") no-repeat center 0;
        font-size: 36px;
        display: flex;
        align-items: center;
        color: white;
    }
    .img2{
        width: 70px;
        height: 70px;
        background: url("../../assets/pointsImgs/pointsHomebg4.png") no-repeat center 0;
        margin: 0 30px;
    }
    .qrCode{
        width: 100px;
        height: 100px;
        background: url("../../assets/pointsImgs/qrCode.png") no-repeat center 0;
        position: absolute;
        top: 10px;
        right: 25px;
    }

    .box{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }
    .content{
        width: 486px;
        height: 300px;
        line-height: 300px;
        border-radius: 20px;
        background-color: rgba(253, 225, 0, 1);
        text-align: center;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
        font-size: 72px;
    }
</style>
